import { useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'

const MarketingImage = ({ name, alt, ...props }) => {
  const data = useStaticQuery(graphql`
    query {
      doorstep: file(relativePath: { eq: "doorstep.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      foodtoorder: file(relativePath: { eq: "foodtoorder.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      marketkitchen: file(relativePath: { eq: "marketkitchen.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      coronationlogo: file(relativePath: { eq: "coronation-logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
      coronationgflags: file(relativePath: { eq: "coronation-flags.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
    }
  `)

  const image = getImage(data?.[name])

  return <GatsbyImage image={image} alt={alt} {...props} />
}

export default MarketingImage
